<!-- <div class="login-container">

  <div class="login-form-container">
    <div class="login-form-content">
      <div class="login-header text-center">
        <h1>Welcome!</h1>
        <p>Sign in to access your ScholarX !</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            formControlName="email"
            placeholder="Enter"
            [class.error]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
          />
          <div class="error-message" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
            Please enter a valid email address
          </div>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            type="password"
            formControlName="password"
            placeholder="Enter"
            [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          />
          <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            Password must be at least 6 characters
          </div>
        </div>

        <div class="remember-me">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="rememberMe" />
            <span class="checkmark"></span>
            Remember me
          </label>
        </div>

  

        <button type="submit" class="login-button" [disabled]="!loginForm.valid || isLoading">
          {{ isLoading ? 'Logging in...' : 'Log In →' }}
        </button>

     
        <div class="error-alert" *ngIf="error">
          {{ error }}
        </div>
      </form>

      <div class="copyright">
        © ScholarX.ai, All rights reserved.
      </div>
    </div>
  </div>


  <div class="marketing-container">
    <div class="marketing-content">
      <img src="assets/ScholarX_Logo_Icon.svg" alt="ScholarX Logo" class="logo" />

      <div class="marketing-text">
        <h2>Instant explanations, study tips, and interactive practice.</h2>
        <p class="marketing-text2">
          Get real-time answers to all your questions, whether they are related to your syllabus or
          beyond, easy-to-understand explanations tailored to your grade level and curriculum.
        </p>
      </div>

      <div class="preview-image">
        <img src="assets/Chat Screen - Shadow 1.svg" alt="ScholarX Interface Preview" />
      </div>
    </div>
  </div>
</div>
 -->

 <!-- intro -->
 <div class="screen-container">
  <!-- Add fadeIn animation to global styles -->
  <style>
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .animate-fadeIn {
      animation: fadeIn 0.8s ease-out forwards;
    }
  </style>

  <!-- Gradient Background - With opacity set to 20% -->
  <div class="gradient-background"></div>

  <!-- Intro Page - Slides up when login appears -->
  <div class="intro-page" [ngStyle]="{'transform': showLogin ? 'translateY(-100%)' : 'translateY(0)'}">
    
    <!-- Background Image Container - Almost full screen -->
    <div class="background-container">
      <img src="assets/_Minimalist modern school.jpg" alt="Modern school interior" class="background-image">
      <div class="overlay"></div>
    </div>

    <!-- Logo and audio controls -->
    <div class="top-nav">
      <div class="logo">
        <img src="assets/ScholarX_Logo_Icon.svg" alt="ScholarX Logo" width="30" height="30">
      </div>
      <!-- <button (click)="toggleMute()" 
              class="audio-button"
              [attr.aria-label]="isMuted ? 'Unmute background music' : 'Mute background music'">
        <svg *ngIf="isMuted" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 5L6 9H2v6h4l5 4V5z"></path>
          <line x1="23" y1="9" x2="17" y2="15"></line>
          <line x1="17" y1="9" x2="23" y2="15"></line>
        </svg>
        <svg *ngIf="!isMuted" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        </svg>
      </button> -->
    </div>

    <!-- Content -->
    <div class="content-container">
      <div class="content-wrapper">
        <!-- Main heading with word-by-word animation -->
        <h1 #headingRef class="main-heading">
          <span *ngFor="let word of headingWords" 
                class="heading-word"
                [ngStyle]="{'animation-delay': word.delay + 's'}">
            {{ word.text }}
          </span>
        </h1>

        <!-- Subtitle with word-by-word animation -->
        <p class="subtitle">
          <span *ngFor="let word of subtitleWords" 
                class="subtitle-word"
                [ngStyle]="{'animation-delay': word.delay + 's'}">
            {{ word.text }}
          </span>
        </p>

        <!-- Enhanced Loading indicator at the bottom -->
        <div class="loading-container">
          <div class="loading-bar-background">
            <div class="loading-bar-progress" [ngStyle]="{'width': loadingProgress + '%'}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Login Page - Already positioned underneath -->
  <div class="login-page" [ngStyle]="{'display': showLogin ? 'block' : 'none'}">
    <!-- Gradient Background - behind everything -->
    <div class="gradient-background"></div>

    <!-- Content container - with decreased equal margins on all sides and NO shadow -->
    <div class="login-container">
      
      <!-- Left side - Login form with white background -->
      <div class="login-form-container">
        <!-- Logo - moved higher -->
        <div class="login-logo">
          <img src="assets/ScholarX_Logo_v2 1.svg" alt="ScholarX Logo" width="100" height="50">
        </div>

        <!-- Login form - moved up -->
        <div class="login-form-wrapper" style="    padding-left: 2%;"> 
          <!-- Hello Again with sun icon -->
          <div class="greeting">
            <h1>Hello !</h1>
            <div class="sun-icon">
              <img src="assets/SmilySun.png" alt="Smiling sun" width="28" height="28">
            </div>
          </div>

          <!-- Subtitle text with pipeline - increased line height -->
          <div class="login-subtitle">
            <div class="vertical-line"></div>
            <div class="login-subtitle-text">
              <p>Login using the credentials provided by your school to access your personalized account</p>
              <p>and Start Learning.</p>
            </div>
          </div>

          <!-- Shorter horizontal divider -->
          <div class="divider"></div>

          <!-- Form with constrained width -->
          <div class="form-container">
            <form (ngSubmit)="handleSubmit()" class="login-form">
              <div class="form-group">
                <input type="email"
                       [(ngModel)]="email"
                       name="email"
                       placeholder="Enter your school email"
                       class="form-input"
                       required>
              </div>
              <div class="form-group password-group">
                <input [type]="showPassword ? 'text' : 'password'"
                       [(ngModel)]="password"
                       name="password"
                       placeholder="Enter your password"
                       class="form-input"
                       required>
                <button type="button"
                        (click)="togglePasswordVisibility()"
                        class="password-toggle"
                        [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                  <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line x1="2" x2="22" y1="2" y2="22"></line>
                  </svg>
                  <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
              </div>
              <button type="submit" class="submit-button">
                Continue learning 
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="arrow-icon">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </button>
            </form>
          </div>
        </div>

        <!-- Footer with increased spacing -->
        <div class="footer">
          <p><span>©</span> ScholarX AI</p>
        </div>
      </div>

      <!-- Right side - Image without animation -->
      <div class="login-image-container">
        <div class="login-image-wrapper">
          <img src="assets/_Minimalist modernschoolclassroomview.jpg" alt="School library interior" class="login-image">
        </div>
      </div>
    </div>
  </div>
</div>
